var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#2A276A;}\n\t.st2{fill:#4843B5;}\n\t.st3{fill:#3A3692;}\n\t.st4{fill:#02C6C0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bookings_Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "622.85,615.6 604.61,605.68 604.76,550.17 622.99,560.09  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "622.85,615.6 622.99,560.09 674.41,552.87 674.31,608.36  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "622.99,560.09 604.76,550.17 656.18,542.95 674.41,552.87  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "699.78,715.76 681.54,705.84 682.11,400.57 700.34,410.49  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "545.71,654.18 527.47,644.27 578.87,637.04 597.11,646.96  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "545.55,709.69 527.32,699.77 527.47,644.27 545.71,654.18  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "545.55,709.69 545.71,654.18 597.11,646.96 597.01,702.46  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "623,532.34 604.77,522.42 604.86,466.85 623.09,476.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "623.09,476.77 604.86,466.85 656.27,459.63 674.51,469.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "545.72,626.44 527.49,616.52 527.52,598.02 545.76,607.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "545.83,570.94 597.26,563.71 597.16,619.21 545.72,626.44 545.76,607.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "545.76,607.94 527.52,598.02 527.59,561.02 545.83,570.94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "545.83,570.94 527.59,561.02 579.03,553.79 597.26,563.71  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "468.56,665.03 450.33,655.11 501.71,647.89 519.94,657.81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "519.94,657.81 519.84,713.3 468.41,720.53 468.56,665.03  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.41,720.53 450.18,710.61 450.33,655.11 468.56,665.03  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "545.86,543.18 527.63,533.26 527.72,477.69 545.96,487.61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "545.96,487.61 527.72,477.69 579.18,470.46 597.42,480.38  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "597.31,535.95 545.86,543.18 545.96,487.61 597.42,480.38  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "623.36,338.08 605.13,328.16 656.55,320.94 674.78,330.85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.57,637.28 450.33,627.36 450.48,571.85 468.72,581.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "468.72,581.77 450.48,571.85 501.86,564.63 520.1,574.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "365.51,762.74 347.27,752.82 681.54,705.84 699.78,715.76  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "391.43,675.87 373.2,665.95 424.62,658.72 442.85,668.64  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.33,731.36 373.1,721.44 373.2,665.95 391.43,675.87  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "391.33,731.36 391.43,675.87 442.85,668.64 442.75,724.14  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "468.72,554.02 450.49,544.1 450.59,488.53 468.83,498.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "468.83,498.45 450.59,488.53 502.02,481.3 520.25,491.22  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "391.48,648.11 373.25,638.19 373.34,582.7 391.58,592.62  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "391.58,592.62 373.34,582.7 424.76,575.47 442.99,585.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "392,370.6 373.77,360.68 425.14,353.46 443.38,363.38  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M674.84,303.09l51.43-7.23l-0.82,443.98l-385.69,54.2l0.82-443.98l51.48-7.23L392,370.6l51.38-7.22 l0.05-27.76l179.99-25.3l-0.05,27.76l51.42-7.23L674.84,303.09z M699.78,715.76l0.57-305.27l-334.27,46.98l-0.57,305.27 L699.78,715.76"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "674.41,525.11 623,532.34 623.09,476.77 674.51,469.55  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "674.78,330.85 656.55,320.94 656.6,293.17 674.84,303.09  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "674.84,303.09 656.6,293.17 708.03,285.95 726.26,295.86  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "520.1,574.55 520,630.05 468.57,637.28 468.72,581.77  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "520.25,491.22 520.15,546.79 468.72,554.02 468.83,498.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "442.89,640.89 391.48,648.11 391.58,592.62 442.99,585.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "443.43,335.61 425.2,325.69 605.18,300.4 623.42,310.32  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "443.38,363.38 425.14,353.46 425.2,325.69 443.43,335.61  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "340.58,350.07 322.34,340.15 373.82,332.92 392.05,342.83  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "339.75,794.05 321.52,784.13 322.34,340.15 340.58,350.07  "
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "506.88,586.8 511.25,590.9 500.12,604.45 495.74,609.78 484.61,623.33 480.25,619.22 491.37,605.68  495.76,600.34  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "500.12,604.45 511.2,614.87 506.82,620.2 495.74,609.78  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "484.68,589.92 495.76,600.34 491.37,605.68 480.29,595.25  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.80de228a93826277717454a468c884db.svg";
export { ForwardRef as ReactComponent };